import React from "react";
import { AlertText } from "../font";

type Props = {
	assessmentType: "concept" | "adCopy";
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PurchaseRateExtractionDefinitionNotes = React.memo(function PurchaseRateExtractionDefinitionNotes({
	assessmentType,
}: Props) {
	const assessmentLabel = assessmentType === "concept" ? "コンセプト" : "コピー";
	return (
		<>
			<AlertText>※直近12か月の購入率をSLI/SCIから確認し入力</AlertText>
			<br />
			<AlertText>　→iCanvas SLI/SCIの出力が「0.19」の場合、0.19と入力</AlertText>
			<div
				className="border border-danger p-1"
				style={{
					fontSize: "0.8rem",
				}}
			>
				<AlertText>対象カテゴリー：{assessmentLabel}テスト品の対象カテゴリーを設定</AlertText>
				<br />
				<AlertText>集計使用サンプル：設定期間全体を通して有効なサンプルを使用＜継続＞</AlertText>
				<br />
				<AlertText>集計期間：直近12か月を設定</AlertText>
				<br />
				<AlertText>フィルタ：年齢（15～69歳）、絞込み用使用者（本人使用+家族と共用）</AlertText>
				<br />
				<AlertText>
					レポートデザイン項目：表側（ブランド・品種・SKU）、表頭（期間全体）、指標（年齢ウェイトつき、購入率・人数（×1））
				</AlertText>
			</div>
		</>
	);
});
